import React from "react";

import type { BadgeListProps } from "@/shared/PostMatchBadge.jsx";
import Badge, { BadgeList, MoreBadges } from "@/shared/PostMatchBadge.jsx";

function Badges({ list, max = 3, size = "medium" }: BadgeListProps) {
  const renderedBadges = [...list]
    .sort((a, b) => b.weight - a.weight)
    .slice(0, max)
    .map((badge, i) => <Badge key={i} {...badge} size={size} />);

  if (list.length > max) {
    const moreBadges = list.slice(max);
    renderedBadges.push(
      <MoreBadges key="more">
        <Badge
          title={[
            "common:countMore",
            "{{count}} More",
            {
              count: moreBadges.length,
            },
          ]}
          size={size}
          style={{
            marginLeft: "calc(var(--sp-3) * -1)",
          }}
        />
        <div className="more">
          {moreBadges.map((badge, i) => (
            <Badge key={i} {...badge} size={size} />
          ))}
        </div>
      </MoreBadges>,
    );
  }

  if (!renderedBadges.length) return null;

  return (
    <BadgeList className="span-all" data-size={size}>
      {renderedBadges}
    </BadgeList>
  );
}

export default Badges;
